import { LOCAL_URL } from '../../helper/constant';
import * as Types from '../../constants/actionTypes';
import AuthAxios from '../../models/Axios'
import axios from 'axios'


export const GET_USER_LOCATION_DETAILS = (payload) => async (dispatch) => {
    try {
        const response = await axios.get(`https://ipapi.co/json`);
        dispatch({ type: Types.USER_LOCATION_DETAILS_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}

export const COUNTRY_DATA = (payload) => async (dispatch) => {
    try {
        let url = `${LOCAL_URL}/countries/getCountryDetailsByCountryCode`;
        let { shortCut } = payload;
        const response = await AuthAxios.axios.get(url, { params: {shortCut: shortCut }});
        dispatch({
            type: Types.COUNTRY_DATA_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.COUNTRY_DATA_ERROR, payload: error })
    }
}

export const COUNTRY_UOM_DATA = (payload) => async (dispatch) => {
    try {
        let url = `${LOCAL_URL}/countries/getCountryUOMDetailsByCountryCode`;
        let { shortCut } = payload;
        const response = await AuthAxios.axios.get(url, { params: {shortCut: shortCut }});
        dispatch({
            type: Types.COUNTRY_UOM_SUCCESS,
            payload: response.data && response.data.data
        })
    } catch (error) {
        dispatch({ type: Types.COUNTRY_DATA_ERROR, payload: error })
    }
}
